var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.66,11,14.84,4.68a1,1,0,1,0-1.41,1.53l4.9,4.52H3a1,1,0,0,0,0,2.08H18.4l-5,5a1,1,0,0,0,.73,1.77,1,1,0,0,0,.74-.3l6.82-6.82a1,1,0,0,0,.31-.76A1.05,1.05,0,0,0,21.66,11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.1bc5fcdf64b54f72a1065e504807b76e.svg";
export { ForwardRef as ReactComponent };